import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "material-ui-snackbar-provider";
import { Row, Col, Spinner } from "react-bootstrap";
import "react-circular-progressbar/dist/styles.css";
import countryList from "country-list";
import countries from "i18n-iso-countries";
import { toast } from "react-toastify";
import AuthContext from "../../context/auth/AuthContext";
import TenantContext from "../../context/tenant/TenantContext";
import useTranslator from "../../hooks/useTranslator";
import moment from "moment";
import constants from "../../Utils/constants";
import LandLordContext from "../../context/landlord/LandLordContext";
import TenantRentalDetails from "../TenantHome/TenantRentalDetails";
import ProfileInfoSection from "../TenantHome/ProfileInfoSection";
import ProfessionalAcademicSection from "../TenantHome/ProfessionalAcademicSection";
import SummarySection from "../TenantHome/SummarySection";
import axiosInstance from "../../services/authWrapper";
import LandlordBlurApprove from "./LandlordBlurApprove";
import {
  calculateEffortRate,
  getIncomeForEffortRate,
  haveValue,
  nl2ul,
  payslipValidityCheck,
  getCustomIncome,
} from "../../helper/common";
import ProfileScore from "../Tenant/ProfileScore";
import EffortRateBar from "./EffortRateBar";
import CombinedIncome from "./CombinedIncome";

countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

const GeneratedReportComponent = (props) => {
  const {
    defaultPropertyLink,
    propList,
    fullinfo,
    rentPercentage = 0,
    setRentPercentage,
    rent_from_income,
    llCreated = false,
    originalUser = null,
    setBestSkor = () => {},
    bestSkor = 0,
    setUserMaxRent = () => {},
    ids,
    index,
    fetchUserById,
    sharedProfileInfo,
  } = props;
  const { _t } = useTranslator();
  const authContext = useContext(AuthContext);
  const { user: landlord_user, loadUser, setLoading } = authContext;
  const landLordContext = useContext(LandLordContext);
  const { saveRentPercentage } = landLordContext;
  const user = props?.scoreProfile;
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const [ident_all, setIdent_all] = useState(false);
  const [linkedPropId, setLinkedPropId] = useState(false);
  const [tenantDocsDataOriginal, setTenantDocsDataOriginal] = useState([]);
  const [tenantDocsData, setTenantDocsData] = useState(null);
  const [ieScore, setIeScore] = useState(0);
  const [otherDocs, setOtherDocs] = useState([]);
  const [publicHousingDocs, setPublicHousingDocs] = useState([]);
  const [docFound, setDocFound] = useState(new Map());
  const [effortObj, setEffortObj] = useState({});
  const [showSpinner, setShowSpinner] = useState();

  //extracting url parameters
  const queryParameters = new URLSearchParams(window.location.search);
  const stepToGo = queryParameters.get("step");
  const error1 = queryParameters.get("error");
  const account_verification_report_id = queryParameters.get(
    "account_verification_report_id"
  );
  const transaction_report_id = queryParameters.get("transaction_report_id");

  useEffect(() => {
    if (haveValue(stepToGo)) {
      if (stepToGo == "linked_props") {
        document
          .getElementsByClassName("accordion-button collapsed")[2]
          .click();
      }
    }
  }, [stepToGo]);

  const [userIncome, setUserIncome] = useState(null);
  const [gurantorsIncome, setGurantorsIncome] = useState([]);
  const [combinedIncome, setCombinedIncome] = useState(0);
  const [incomeSources, setIncomeSources] = useState(null);

  useEffect(() => {
    // console.log(user?._id, sharedProfileInfo?.tenantid?._id);
    if (
      user?._id &&
      sharedProfileInfo?.tenantid?._id &&
      user._id !== sharedProfileInfo.tenantid._id
    ) {
      return;
    }
    const user_income_sources =
      user?.income_selection ?? sharedProfileInfo?.income_selection;
    setIncomeSources(user_income_sources);

    const user_income = getCustomIncome(
      user,
      landlord_user,
      _t,
      user_income_sources?.tenant_source
    );
    setUserIncome(user_income);

    const updatedIncomeSource = {
      ...user_income_sources,
      tenant_source: user_income?.source || user_income_sources?.tenant_source,
    };

    setIncomeSources(updatedIncomeSource);

    // gurantor's income
    let totalGurantorIncome = 0;
    let allGurantorIncomes = [];
    let allGurantors = user?.gurantor_id;
    const gurantor_income_sources = user_income_sources?.guarantor_sources;

    if (Array.isArray(allGurantors)) {
      allGurantors.forEach((gurantor) => {
        if (haveValue(gurantor)) {
          const income = getCustomIncome(
            gurantor,
            landlord_user,
            _t,
            gurantor_income_sources?.[gurantor?._id]
          );
          totalGurantorIncome += income?.amount || 0;
          allGurantorIncomes.push(income);
        }
      });
    }
    setGurantorsIncome(allGurantorIncomes);

    const combinedIncome = +user_income?.amount + +totalGurantorIncome;
    setCombinedIncome(combinedIncome);

    setUserMaxRent((prev) => ({
      ...prev,
      [user?._id]: combinedIncome ?? 0,
    }));

    if (originalUser?.role == "landlord") {
      let temp_obj = calculateEffortRate(
        combinedIncome,
        originalUser,
        fullinfo
      );
      setEffortObj(temp_obj);
    } else {
      setEffortObj({
        annual_sal: combinedIncome * 12,
        monthly_sal: combinedIncome,
        effort_rate: 100,
        effort_amount: combinedIncome / 2,
      });
    }
  }, [user, sharedProfileInfo]);

  // useEffect(() => {
  //   if (haveValue(effortObj?.effort_amount))
  //     setUserMaxRent((prev) => ({
  //       ...prev,
  //       [user?._id]: effortObj?.effort_amount ?? 0,
  //     }));
  // }, [effortObj]);

  useEffect(() => {
    if (haveValue(tenantDocsData) && tenantDocsData.length >= 1) {
      const temp_map = new Map();
      const type_map = new Map();
      const other_type = [];
      const public_housing_docs_map = new Map();
      // console.log(tenantDocsData, "IN USEEFFECT tenantDocsData");
      tenantDocsData.map((docs) => {
        if (docs?.from == "clave") {
          temp_map.set(docs?.type);
        }
        if (
          !type_map.has(docs?.type + (docs?.year ? docs?.year : "")) &&
          docs?.from != constants.others
        ) {
          type_map.set(docs?.type + (docs?.year ? docs?.year : ""), docs);
        }
        if (docs?.from == "others") {
          other_type.push(docs);
        }
        if (docs?.from == "public_housing_docs") {
          const existing = public_housing_docs_map.get(docs.type);
          if (
            !existing ||
            new Date(docs.created_at) > new Date(existing.created_at)
          ) {
            public_housing_docs_map.set(docs.type, docs);
          }
        }
      });
      const public_housing_docs_sorted = Array.from(
        public_housing_docs_map.values()
      ).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      setOtherDocs(other_type);
      setPublicHousingDocs(public_housing_docs_sorted);
      setDocFound(type_map);
    }
  }, [tenantDocsData]);

  useEffect(() => {
    const temp_doc = new Map();
    tenantDocsDataOriginal.map((val) => {
      if (!temp_doc.has(val?.type)) {
        temp_doc.set(val?.type, val);
      }
    });

    setTenantDocsData(Array.from(temp_doc.values()));
  }, [tenantDocsDataOriginal]);

  useEffect(() => {
    //console.log("kyc page -----", account_verification_report_id);

    if (error1) {
      toast.error(_t("bankDetailsCannotBeFetched"));
    }
    if (account_verification_report_id && transaction_report_id) {
      // snackbar.showMessage(_t("Connected to Bank"));
      let userid = user?._id;
      if (!userid) {
        toast.error(_t("userNotAuthorized"));
      } else {
        //console.log("Calculate Score============>");
        calculateScore(
          userid,
          account_verification_report_id,
          transaction_report_id
        );
      }
    }
  }, [account_verification_report_id]);

  const enhancedOptions = [
    ...propList,
    {
      label: <CustomButton />,
      value: "button",
      isDisabled: true, // Prevents selection
    },
  ];

  function CustomButton() {
    return (
      <div
        className="w-full h-full "
        style={{
          width: "100%",
          position: "absolute",
        }}
      >
        <button
          onClick={(e) => {
            e.stopPropagation(); // Prevents dropdown from closing
            navigate("/landlord/add-property"); // Navigate to a new page
          }}
          className="w-full h-full rounded text-center py-2"
        >
          {_t(
            "addNewProp",
            "In landlord side while linked properties select is open to add new prop"
          )}
        </button>
      </div>
    );
  }

  const calculateScore = async (
    userid,
    accountverificationid,
    transactionreportid
  ) => {
    //console.log("payment score calculations");
    // setBankDiv("kyc-loading");
    await clearPaymentData(userid);
    calculatePaymentScore(userid, accountverificationid, transactionreportid);
  };

  const clearPaymentData = async (tenantid) => {
    //console.log("Clearing Payment Data ===========>> ",);
    return new Promise((resolve) => {
      axiosInstance
        .delete(
          `${process.env.REACT_APP_SERVER_URL}/tenants/algoan-info?tenantid=${tenantid}`
        )
        .then((res) => {
          //console.log(res);
          //console.log("previous data cleared");
          return resolve(true);
        })
        .catch((err) => {
          let err_res = err;
          toast.error(err_res.message);
          return resolve(null);
        });
    });
  };

  const calculatePaymentScore = async (
    userid,
    accountverificationid,
    transactionreportid
  ) => {
    // setLoading(true)
    await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/calculatescore?tenantid=${userid}&accountverificationid=${accountverificationid}&transactionreportid=${transactionreportid}`
      )
      .then((res) => {
        let serverResponse = res.data;
        //console.log(serverResponse);
        if (serverResponse.status !== "success") {
          if (serverResponse.status == "pending") {
            loadUser(userType);
          } else {
            loadUser(userType);
          }
        }
        if (serverResponse.status === "success") {
          toast.success(_t("bankConnectedSuccessfully"));
          loadUser(userType);
          // setBankDiv("kyc-loaded");
        }
        // setLoading(false)
      })
      .catch((err) => {
        let err_res = err;
        // setLoading(false)
        //console.log(err_res);
      });
  };

  const countries1 = countryList.getData();
  const getAlpha3Code = (countryName) => {
    const country = countries1.find(
      (c) => c.name?.toLowerCase() === countryName
    );
    return country ? countries.alpha2ToAlpha3(country.code) : "Not found";
  };

  const alpha3ToName = (code) => {
    return countries.getName(code, "en");
  };
  // const { userType } = authContext;
  const userType = localStorage.getItem("usertype");
  console.log(userType, " from Auth Context");
  const [showGurantor, setShowGurantor] = useState(false);
  const [guarantorData, setGuarantorData] = useState({
    gurantor_name: "",
    gurantor_email: "",
  });

  const tenantContext = useContext(TenantContext);
  const {
    myRentedProperties,
    myPreviouslyRentedProperties,
    getKycDocs,
    kycuserinfo,
    fetchTenantDocs,
    getDocumentAnalysis,
    getZipDocs,
  } = tenantContext;

  const pathcolor = "";
  const [progressColor, setProgressColor] = useState("#F27833");

  const [error, setError] = useState(false);
  const [offers, setOffers] = useState([]);
  const [scoreError, setScoreError] = useState({});
  const [scoreLoading, setScoreLoading] = useState(false);
  const [userKycInfo, setUserKycInfo] = useState({});
  const [recordedSalary, setRecordedSalary] = useState({
    salary: 0,
    matched: 0,
  });
  //console.log("RECORDED SALARY = ", recordedSalary);
  const [isEmployeementDataSet, setIsEmployeementDataSet] = useState(false);
  const [haveGuarantor, setHaveGuarantor] = useState(false);

  const shareLink = (tenantid) => {
    let sharing_url = `https://${process.env.REACT_APP_URL_NAME}/profile-sharing/${tenantid}`;
    navigator.clipboard.writeText(sharing_url);
    //toast.success("Sharing Link has been copied");
    snackbar.showMessage("sharingLinkHasBeenCopied");
  };

  useEffect(() => {
    loadOffers();
    if (!user?.analysisCompleted && user?.algoanAnalysis) {
      getAnalysisDetails();
      setScoreLoading(true);
    }

    myRentedProperties(user?._id);
    myPreviouslyRentedProperties(user?._id);

    if (!user?.onfido_kyc_success) {
      getKycReport(user?._id);
    }

    if (user?.employment_status == constants.employed) {
      if (user?.name_of_company && user?.position && user?.type_of_employee) {
        setIsEmployeementDataSet(true);
      }
    }

    if (
      user?.have_gurantor == "no" ||
      user?.have_gurantor == null ||
      user?.haveGuarantor == false
    ) {
      setHaveGuarantor(false);
    } else {
      setHaveGuarantor(true);
    }

    fetchFileData();
    loadUser(userType);
  }, []);
  useEffect(() => {
    const temp_id = defaultPropertyLink.map((prop) => prop.value);

    setLinkedPropId(temp_id);
  }, [defaultPropertyLink]);

  useEffect(() => {
    checkSalary();
    getkycDetails();
  }, [kycuserinfo]);

  useEffect(() => {
    checkAllMatches();
    calculateIeScore();
  }, [user, userKycInfo]);

  useEffect(() => {
    const currentScore = haveValue(
      user?.gurantor_id?.paymentScores?.creditScore?.value
    )
      ? user?.gurantor_id?.paymentScores?.creditScore?.value
      : user?.ie_verified && user?.is_university
      ? ieScore
      : user?.paymentScores?.creditScore?.value;

    if (currentScore > bestSkor) {
      setBestSkor(currentScore);
    }
  }, [user, ieScore]);

  const calculateIeScore = () => {
    var totalScore = (user?.paymentScores?.creditScore?.value || 0) / 2;

    if (user?.ie_verified && user?.is_university) {
      if (totalScore >= 600) {
        totalScore += 200;
      } else {
        totalScore += 400;
      }
    }
    if (totalScore > 850) {
      totalScore = 850;
    }
    setIeScore(totalScore);
  };

  const checkSalary = () => {
    // if (haveValue(user?.gurantor_id)) {
    //   if (user?.gurantor_id?.algoanIncome) {
    //     let monthlyIncome = parseInt(
    //       user?.gurantor_id?.algoanIncome?.monthlyAmount
    //     );
    //     let recorded_annual_salary = monthlyIncome * 12;

    //     let userIncome = parseInt(
    //       haveValue(user?.gurantor_id?.current_annual_income)
    //         ? user?.gurantor_id?.current_annual_income
    //         : 0
    //     );
    //     let salaryMatch = Math.round(
    //       (recorded_annual_salary / userIncome) * 100
    //     );

    //     setRecordedSalary({
    //       ...recordedSalary,
    //       matched: salaryMatch,
    //       salary: recorded_annual_salary,
    //     });
    //   }
    // } else {
    if (user?.algoanIncome) {
      let monthlyIncome = parseInt(user?.algoanIncome?.monthlyAmount);
      let recorded_annual_salary = monthlyIncome * 12;

      let userIncome = parseInt(
        haveValue(user.current_annual_income) ? user.current_annual_income : 0
      );
      let salaryMatch = Math.round((recorded_annual_salary / userIncome) * 100);

      setRecordedSalary({
        ...recordedSalary,
        matched: salaryMatch,
        salary: recorded_annual_salary,
      });
    }
    // }
  };

  const getkycDetails = () => {
    let userid = user?._id;
    if (user?.onfido_kyc_success) {
      //// console.log("kyc has been done");
      loadKycReport(userid);
    } else {
      //// console.log("kyc has  been done but result has not been fetched");
      getKycReport(userid);
    }
  };

  const loadKycReport = async (tenantid) => {
    await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/getkycreport/${tenantid}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        //// console.log(res);
        //toast.success("KYC Report Fetched");
        setUserKycInfo(res.data.kycuser);
      })
      .catch((err) => {
        //console.log(err);
        //toast.error("Kyc Report Not Fetched")
      });
  };

  const getKycReport = async (tenantid) => {
    if (haveValue(tenantid)) {
      let myInterval = setInterval(async () => {
        await axiosInstance
          .get(
            `${process.env.REACT_APP_SERVER_URL}/tenants/getkycstatus/${tenantid}`,
            {
              headers: {
                "Accept-Language": localStorage.getItem("i18nextLng"),
              },
            }
          )
          .then((res) => {
            ////  console.log(res);
            if (res.data.status === "success") {
              //toast.success("KYC Report Fetched")
              setUserKycInfo(res.data.kycuser);
              clearInterval(myInterval);
            } else {
              clearInterval(myInterval);
            }
          })
          .catch((err) => {
            clearInterval(myInterval);
          });
      }, 3000);
    }
  };

  const getAnalysisDetails = async (req, res) => {
    let userid = user?._id;

    let myInterval = setInterval(async () => {
      //console.log("interval started running");

      await axiosInstance
        .get(
          `${process.env.REACT_APP_SERVER_URL}/tenants/checkmyanalysis/${userid}`,
          { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
        )
        .then((res) => {
          //// console.log(res);
          setScoreLoading(false);
          clearInterval(myInterval);
          //// console.log("interval stopped");
          loadUser(userType);
        })
        .catch((err) => {
          setScoreLoading(false);
          //// console.log(err.response.data);
          setScoreError(err.response.data);
          clearInterval(myInterval);
          return;
        });
    }, 4000);
  };

  const loadOffers = async () => {
    let url = `${process.env.REACT_APP_SERVER_URL}/offers/`;
    await axiosInstance
      .get(url, {
        headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
      })
      .then((res) => {
        setLoading(false);
        setOffers(res.data.offers);
        //// console.log(res);
      })
      .catch((err) => {
        setLoading(false);
        setError(true);
        //console.log(err);
      });
  };

  const checkAllMatches = async () => {
    let fname = user?.fname.toString();
    let lname = user?.lname.toString();
    let newName = fname.split(" ");
    let newLname = lname.split(" ");

    let temp_fname = "";
    for (let i = 0; i < newName.length; i++) {
      newName[i] = newName[i]?.toLowerCase();
      temp_fname = temp_fname + newName[i];
    }

    let temp_lname = "";
    for (let i = 0; i < newLname.length; i++) {
      newLname[i] = newLname[i]?.toLowerCase();
      temp_lname = temp_lname + newLname[i];
    }

    let user_fullname = temp_fname + temp_lname;

    let kyc_fullname = "";
    if (
      (userKycInfo?.onfido_doc_data?.first_name,
      userKycInfo?.onfido_doc_data?.last_name)
    ) {
      let kyc_fname = userKycInfo?.onfido_doc_data?.first_name;
      let kyc_lname = userKycInfo?.onfido_doc_data?.last_name;

      let kycName = kyc_fname.split(" ");
      let kycLname = kyc_lname.split(" ");

      let temp_fname1 = "";
      for (let i = 0; i < newName.length; i++) {
        if (kycName[i]) {
          kycName[i] = kycName[i]?.toLowerCase();
          temp_fname1 = temp_fname1 + kycName[i];
        }
      }

      let temp_lname1 = "";
      for (let i = 0; i < newLname.length; i++) {
        if (kycLname[i]) {
          kycLname[i] = kycLname[i]?.toLowerCase();
          temp_lname1 = temp_lname1 + kycLname[i];
        }
      }

      kyc_fullname = temp_fname1 + temp_lname1;
    }
    if (user?.onfido_kyc_success == false) {
      setIdent_all(false);
      return false;
    }

    var kyc_nationality = "";
    if (userKycInfo?.onfido_doc_data?.nationality)
      kyc_nationality =
        userKycInfo?.onfido_doc_data?.nationality?.toLowerCase();

    setIdent_all(true);
    return true;
  };

  const [rentDoc, setRentDoc] = useState("");
  const [rentValFrom, setRentValFrom] = useState(0);
  useEffect(() => {
    if (haveValue(recordedSalary.salary)) {
      if (haveValue(rent_from_income)) {
        console.log("rent_from_income", rent_from_income);
        setRentDoc(rent_from_income);
      } else if (haveValue(user?.current_annual_income)) {
        setRentDoc("current_annual_income");
      } else if (haveValue(user?.itr_amount)) {
        console.log("itr_amount");
        setRentDoc("itr_amount");
      } else {
        console.log("recordedSalary");
        setRentDoc("recordedSalary");
      }
    }
  }, [rent_from_income, recordedSalary]);

  useEffect(() => {
    if (originalUser?.role == "landlord") {
      handleRentDocChange();
    }
  }, [rentDoc, recordedSalary]);
  const handleRentDocChange = () => {
    if (rentDoc == "current_annual_income") {
      setRentValFrom(user?.current_annual_income);
    }
    if (rentDoc == "itr_amount") {
      setRentValFrom(user?.itr_amount);
    }
    if (rentDoc == "recordedSalary") {
      setRentValFrom(recordedSalary?.salary);
    }

    const data = {
      shared_profile_id: queryParameters.get("sharedprofileid"),
      agencylink: queryParameters.get("agencylink"),
      rent_from_income: rentDoc,
    };
    saveRentPercentage(data);
  };

  const fetchFileData = async () => {
    let userid = user?._id;
    const res = await fetchTenantDocs(userid, llCreated);
    // console.log(res.data.success_res.tenantDocs, "IN THIS FUNCTION");
    setTenantDocsData(res.data.success_res.tenantDocs);
  };

  const handleZipDown = () => {
    setShowSpinner(true);
    getZipDocs(user?._id)
      .then((res) => {
        const nodeJSBuffer = res.data.images.data;
        const uint8Array = new Uint8Array(nodeJSBuffer);

        // Convert Uint8Array to ArrayBuffer
        const arrayBuffer = uint8Array.buffer;

        // Create a Blob
        const blob = new Blob([arrayBuffer], {
          type: "application/octet-stream",
        });

        // Create a download link
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "documents.zip";

        document.body.appendChild(a);
        a.click();

        // Clean up
        document.body.removeChild(a);
        URL.revokeObjectURL(a.href);
        setShowSpinner(false);
      })
      .catch((err) => {
        setShowSpinner(false);
        console.log(err);
      });
  };

  return (
    <>
      <div id="onfido-mount"></div>

      <div className="tabs-box-pattern">
        <div id="main-content">
          <div id="page-container" className="tab-content">
            <div id="home" className="tab-pane active padding-full-zero">
              <div className="tabs-item d-block">
                <div className="userscrollprofile-topbar">
                  {
                    <>
                      <div className="mx-0 pdf-content-area d-flex justify-content-between align-items-center">
                        <h2 className="pdf-main-heading">
                          {ids.length > 1
                            ? `${_t("candidate")} - ${index + 1}`
                            : _t("candidacyReport")}
                        </h2>
                        <a href="/">
                          <img src="/images/black-skor-logo.svg" alt="logo" />
                        </a>
                      </div>
                      <div className="border-pd card-wrapper mx-custom-gap">
                        <Row className="mx-0 child-height-set">
                          <>
                            <Col xl={6} className="mb-3">
                              <div className="profile-summary border-pd  p-0 ">
                                <h2 className="green-bg-heading mb-4">
                                  <div className="heading-icon-wrapper">
                                    <img
                                      className="heading-icon"
                                      src="/images/green-meter.svg"
                                      alt="icon"
                                    />
                                  </div>
                                  <span>{_t("skor")}</span>
                                </h2>
                                {haveValue(
                                  user?.paymentScores?.creditScore?.value
                                ) ||
                                (user?.ie_verified && user?.is_university
                                  ? user?.kyc_success
                                    ? haveValue(user?.paymentScores)
                                    : !haveValue(user?.paymentScores)
                                  : false) ? (
                                  <>
                                    <ProfileScore
                                      creditScore={
                                        user?.ie_verified && user?.is_university
                                          ? ieScore
                                          : user?.paymentScores?.creditScore
                                              ?.value
                                      }
                                      rentScore={
                                        user?.rental_skor < 200
                                          ? user?.rental_skor || 0
                                          : 200
                                      }
                                    >
                                      <h1>
                                        {(user?.ie_verified &&
                                        user?.is_university
                                          ? ieScore
                                          : user?.paymentScores?.creditScore
                                              ?.value) +
                                          (user?.rental_skor || 0)}
                                      </h1>
                                    </ProfileScore>
                                    <div className="name-box-new">
                                      <h3 className="score-name mt-0">
                                        {haveValue(
                                          user?.kyc_details
                                            ?.userDataByProvider[0]?.accounts[0]
                                            ?.holderName
                                        )
                                          ? user?.kyc_details
                                              ?.userDataByProvider[0]
                                              ?.accounts[0]?.holderName
                                          : `${user?.fname} ${user?.lname}`}
                                        {"*"}
                                      </h3>
                                      <div className="expiry-skor-date">
                                        <span>
                                          {_t("createdOn")}:{" "}
                                          {moment(
                                            haveValue(
                                              user?.bankVerificationDate
                                            )
                                              ? user?.bankVerificationDate
                                              : user?.created_at
                                          ).format("DD-MM-YYYY")}
                                        </span>
                                        <span>
                                          {_t("validTill")}:{" "}
                                          {moment(
                                            haveValue(
                                              user?.bankVerificationDate
                                            )
                                              ? user?.bankVerificationDate
                                              : user?.created_at
                                          )
                                            .add(2, "months")
                                            .format("DD-MM-YYYY")}
                                        </span>
                                      </div>
                                      <ul className="score-textgray">
                                        {user?.ie_verified &&
                                        user?.is_university &&
                                        !haveValue(
                                          user?.paymentScores?.creditScore
                                            ?.value
                                        ) ? (
                                          <span>
                                            *{_t("skorBasedOnIEProfile")}{" "}
                                          </span>
                                        ) : (
                                          <span>
                                            *{_t("bankAccountUsedForScoring")}{" "}
                                          </span>
                                        )}
                                      </ul>
                                    </div>
                                    <div className="totalIncomeWrapper">
                                      <CombinedIncome
                                        combinedIncome={combinedIncome}
                                        userIncome={userIncome}
                                        gurantorsIncome={gurantorsIncome}
                                      />
                                    </div>

                                    {originalUser?.role == "landlord" ? (
                                      <>
                                        <div className="score-meter-capsule-wrapper py-0">
                                          <div
                                            className="d-flex justify-space-between align-items-end gap-1 effort-rate"
                                            style={{ marginBottom: "5px" }}
                                          >
                                            <span className="effort-rate-head">
                                              {_t("effortRate")}
                                            </span>
                                            <span className="flex-1 dotted-border-b"></span>
                                            <span className="effort-rate-percentage">
                                              {effortObj?.effort_rate}%
                                            </span>
                                          </div>
                                        </div>
                                        <p className="d-flex justify-content-between align-items-center orange-note-box">
                                          <span className="orange-note-head">
                                            {_t("maximumRent")}
                                          </span>
                                          <span className="orange-note-price">
                                            {!Number.isNaN(
                                              Number(effortObj?.effort_amount)
                                            )
                                              ? Math.round(
                                                  Number(
                                                    effortObj.effort_amount
                                                  )
                                                )
                                              : 0}
                                            €
                                          </span>
                                        </p>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <div className="score-content-area">
                                      <p className="no-score-text">
                                        {_t("noSkorAvailable")}
                                      </p>
                                      <CombinedIncome
                                        combinedIncome={combinedIncome}
                                        userIncome={userIncome}
                                        gurantorsIncome={gurantorsIncome}
                                      />
                                      <div className="score-detail-box">
                                        <EffortRateBar
                                          effortObj={effortObj}
                                          hideSlider={true}
                                          profileUser={user}
                                        />
                                        {originalUser?.role == "landlord" ? (
                                          <p className="d-flex justify-content-between align-items-center orange-note-box">
                                            <span className="orange-note-head">
                                              {_t("maximumRent")}
                                            </span>
                                            <span className="orange-note-price">
                                              {!Number.isNaN(
                                                Number(effortObj?.effort_amount)
                                              )
                                                ? Math.round(
                                                    Number(
                                                      effortObj.effort_amount
                                                    )
                                                  )
                                                : 0}
                                              €
                                            </span>
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </Col>
                          </>

                          <Col xl={6} className="mb-3">
                            <div className="profile-summary border-pd  p-0 ">
                              <h2 className="green-bg-heading">
                                <div className="heading-icon-wrapper">
                                  <img
                                    className="heading-icon"
                                    src="/images/document-icon.svg"
                                    alt="icon"
                                  />
                                </div>
                                <span>{_t("profileSummary")}</span>
                              </h2>

                              <p className="profile-summary-desc box-content-area">
                                {haveValue(user?.profileSummary) ? (
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: nl2ul(
                                        landlord_user?.lang == "es"
                                          ? user?.profileSummaryEs
                                          : user?.profileSummary
                                      ),
                                    }}
                                  />
                                ) : (
                                  _t("profileSummaryNotGenerated")
                                )}
                              </p>
                            </div>
                          </Col>

                          <ProfileInfoSection
                            user={user}
                            alpha3ToName={alpha3ToName}
                            userKycInfo={userKycInfo}
                            setShowPhoneVerificationdModal={(e) => {
                              console.log("Only Valid For Tenant Profile!");
                            }}
                            handleRemoveGuarantor={(e) => {
                              console.log("Only Valid For Tenant Profile!");
                            }}
                            handleGurantorModal={(e) => {
                              console.log("Only Valid For Tenant Profile!");
                            }}
                            showActionPrompts={false}
                            sharersData={fullinfo?.sharersData ?? []}
                            isLandlord={landlord_user?.role == "landlord"}
                            landlord_user={landlord_user}
                          />

                          <SummarySection
                            user={user}
                            ident_all={ident_all}
                            recordedSalary={recordedSalary}
                            haveGuarantor={haveGuarantor}
                            rentDoc={rentDoc}
                            setRentDoc={setRentDoc}
                            rentPercentage={rentPercentage}
                            setRentPercentage={setRentPercentage}
                            rentValFrom={rentValFrom}
                            isLandlord={landlord_user?.role == "landlord"}
                            landlord_user={landlord_user}
                            isReport={true}
                          />

                          <ProfessionalAcademicSection
                            user={user}
                            recordedSalary={recordedSalary}
                            showActionPrompts={false}
                            landlord_user={landlord_user}
                            isLandlord={landlord_user?.role == "landlord"}
                            incomeSources={incomeSources}
                            fullinfo={sharedProfileInfo}
                            showIncomeHighlight={true}
                            allowIncomeSourceChange={false}
                          />
                          <Col xl={6} className="mb-3 personal-info-card">
                            <div className="profile-summary border-pd  p-0 ">
                              <h2 className="green-bg-heading">
                                <div className="heading-icon-wrapper">
                                  <img
                                    className="heading-icon"
                                    src="/images/documents-icon.svg"
                                    alt="icon"
                                  />
                                </div>
                                <span>{_t("documents")}</span>
                                {showSpinner ? (
                                  <Spinner className="view_document_spinner" />
                                ) : (
                                  <a href={undefined} onClick={handleZipDown}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                    >
                                      <path
                                        d="M9 13.5L3.375 7.875L4.95 6.24375L7.875 9.16875V0H10.125V9.16875L13.05 6.24375L14.625 7.875L9 13.5ZM2.25 18C1.63125 18 1.10175 17.7799 0.6615 17.3396C0.22125 16.8994 0.00075 16.3695 0 15.75V12.375H2.25V15.75H15.75V12.375H18V15.75C18 16.3687 17.7799 16.8986 17.3396 17.3396C16.8994 17.7806 16.3695 18.0007 15.75 18H2.25Z"
                                        fill="#EF7833"
                                      />
                                    </svg>
                                  </a>
                                )}
                              </h2>
                              <div className="box-content-area">
                                <div className="doc-names-wrapper">
                                  {[...docFound.entries()].map(
                                    ([type, doc]) => (
                                      <div
                                        className="d-flex align-items-center doc-name-wrapper cursor-pointer"
                                        onClick={(e) =>
                                          window.open(
                                            `${process.env.REACT_APP_SERVER_URL}/uploads/${doc?.file_name}`,
                                            "blank"
                                          )
                                        }
                                      >
                                        <div className="green-circle-icon">
                                          <img
                                            className="dark-doc-icon"
                                            src="/images/dark-document.svg"
                                            alt=""
                                          />
                                        </div>

                                        <p className="doc-name-text">
                                          {_t(type, "", "fixed")}
                                        </p>
                                        {(doc?.from == "clave" ||
                                          doc?.type ==
                                            "Last annual Tax Report (Model 100)" ||
                                          (doc?.type == "1st month payslip" &&
                                            payslipValidityCheck(
                                              user?.tenant_extra_field_id
                                                ?.payslip_data?.payslip1,
                                              user
                                            )) ||
                                          (doc?.type == "2nd month payslip" &&
                                            payslipValidityCheck(
                                              user?.tenant_extra_field_id
                                                ?.payslip_data?.payslip2,
                                              user
                                            )) ||
                                          (doc?.type == "3rd month payslip" &&
                                            payslipValidityCheck(
                                              user?.tenant_extra_field_id
                                                ?.payslip_data?.payslip3,
                                              user
                                            ))) && (
                                          <img
                                            src="/images/tick-new.svg"
                                            alt=""
                                            className="green-check-icon"
                                          />
                                        )}
                                      </div>
                                    )
                                  )}
                                  {[...otherDocs.entries()].map(
                                    ([index, doc]) => (
                                      <div
                                        className="d-flex align-items-center doc-name-wrapper cursor-pointer"
                                        onClick={(e) =>
                                          window.open(
                                            `${process.env.REACT_APP_SERVER_URL}/uploads/${doc?.file_name}`,
                                            "blank"
                                          )
                                        }
                                      >
                                        <div className="green-circle-icon">
                                          <img
                                            className="dark-doc-icon"
                                            src="/images/dark-document.svg"
                                            alt=""
                                          />
                                        </div>

                                        <p className="doc-name-text">
                                          {_t(doc?.type, "", "fixed")}
                                        </p>
                                      </div>
                                    )
                                  )}
                                  {[...publicHousingDocs.entries()].map(
                                    ([index, doc]) => (
                                      <div
                                        className="d-flex align-items-center doc-name-wrapper cursor-pointer"
                                        onClick={(e) =>
                                          window.open(
                                            `${process.env.REACT_APP_SERVER_URL}/uploads/${doc?.file_name}`,
                                            "blank"
                                          )
                                        }
                                      >
                                        <div className="green-circle-icon">
                                          <img
                                            className="dark-doc-icon"
                                            src="/images/dark-document.svg"
                                            alt=""
                                          />
                                        </div>

                                        <p className="doc-name-text">
                                          {_t(doc?.type, "", "fixed")}
                                        </p>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneratedReportComponent;
